import PanicAlarmCentralPopupComponent from 'components/PanicAlarmCentralPopupComponent';
import { AppContext } from 'context/AppContextProvider';
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { useGetVirtualAlarmCentralById } from 'services/AlarmCentralService/Virtual/hooks/useMutation';
import { IVirtualAlarmCentralProps } from 'services/AlarmCentralService/Virtual/types';

interface AlarmCentralVirtualContextProviderProps {
  children: ReactNode;
}

interface IVirtualAlarmCentralVirtualContextData {
  alarmCentral: IVirtualAlarmCentralProps;
  requestAlarmCentral: () => void;
}

export const AlarmCentralVirtualContext = createContext(
  {} as IVirtualAlarmCentralVirtualContextData,
);

const AlarmCentralVirtualContextProvider = ({
  children,
}: AlarmCentralVirtualContextProviderProps) => {
  const { id } = useParams();
  const [alarmCentral, setAlarmCentral] = useState<IVirtualAlarmCentralProps>(
    {} as IVirtualAlarmCentralProps,
  );
  const { showSnackbar } = useContext(AppContext);

  const { mutateAsync } = useGetVirtualAlarmCentralById();

  const requestAlarmCentral = () => {
    if (id) mutateAsync(Number.parseInt(id)).then(setAlarmCentral);
  };
  useEffect(() => {
    requestAlarmCentral();
  }, [id]);

  return (
    <AlarmCentralVirtualContext.Provider
      value={{ alarmCentral, requestAlarmCentral }}
    >
      {children}
      <PanicAlarmCentralPopupComponent />
    </AlarmCentralVirtualContext.Provider>
  );
};

export default AlarmCentralVirtualContextProvider;
